import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'
import authconfig from './common/auth'

import bootstrap from 'bootstrap'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueAnalytics from 'vue-analytics'
import VueFormWizard from 'vue-form-wizard'
import Multiselect from 'vue-multiselect'
import VueSweetalert2 from 'vue-sweetalert2'
import VueLazyLoad from 'vue-lazyload'
import VueCarousel from 'vue-carousel'
import VCalendar from 'v-calendar'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import VueContentPlaceholders from 'vue-content-placeholders'

import '@/assets/scss/app.scss'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import Vuex from 'vuex'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VuexPersistence from 'vuex-persist'
import VueCurrencyFilter from 'vue-currency-filter'
import VueClipboard from 'vue-clipboard2'
import VModal from 'vue-js-modal'
import {ClickOutsideDirective} from "@/directives";
// import { VueReCaptcha } from 'vue-recaptcha-v3'

import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

library.add(fab, fad, fas, far, fal)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('multiselect', Multiselect)


// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

//  Recaptcha
// Vue.use(VueReCaptcha, { siteKey: '6LdIgvkaAAAAAGGltUcRNyj0rEzKStk1zE2RDMyV', loaderOptions: {autoHideBadge: true,} })

import Zendesk from '@dansmaculotte/vue-zendesk'

Vue.use(Zendesk, {
  key: '044ace75-a635-40f6-8382-42137ca2037d',
  disabled: false,
  hideOnLoad: false,
  settings: {
    webWidget: {
      color: {
        theme: '#72b239'
      }
    }
  }
})

Vue.use(Vuex)
Vue.use(VueSweetalert2)
Vue.use(VCalendar)

Vue.use(VueClipboard)
Vue.use(VueFormWizard)
Vue.use(require('vue-moment'))
Vue.use(VueSweetalert2)
Vue.use(lodash, VueLodash)
Vue.use(VueCurrencyFilter, {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
})
Vue.use(VueLazyLoad)
Vue.use(VueCarousel)
Vue.use(VModal, {
    dynamic: true
})
Vue.use(VueNumberInput)
Vue.use(VueContentPlaceholders)

Vue.router = router

Vue.use(VueAxios, axios)
axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api`;
axios.defaults.withCredentials = true;
Vue.use(VueAuth, authconfig)

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_IDS.split(','),
    debug: {
        enabled: process.env.NODE_ENV === 'production',
        sendHitTask: process.env.NODE_ENV === 'production'
    },
    ready () {
        // require the ecommerce plugin
        Vue.$ga.require('ecommerce')
    },
    // ecommerce: {
    //     enabled: true,
    //     enhanced: true
    // },
    router
})

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
